import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../auth.service';
import { ResearchExportPayload } from '../../models/school/research-export.model';

@Injectable({
  providedIn: 'root'
})
export class AdminSchoolYearResearchExportService {

  constructor(private authSv: AuthService) {}

  generateExport(schoolYearId: string, payload: ResearchExportPayload): Observable<Blob> {
    return this.authSv.postForFile(`/admin/schoolYears/${schoolYearId}/researchExport`, payload);
  }
}
